import { CheckSeat } from "./check-seat.model";

export class Check {
	source: string;
	created: string;
	dueDateTime: string;
	open: boolean;
	futureOrder: boolean;

	checkKey: string;
	venueKey: number;
	checkNumber: number;
	table: string;
	updated: string;
	timestamp: string;
	timeOpened: string;
	businessDate: string;
	orderType: number;
	orderTypeName: string;
	subtotal: number;
	taxtotal: number;
	discountTotal: string;
	orderTypeChargeTotal: string;
	gratuityTotal: string;
	creditCardPassAlongFee: string;
	total: string;
	remainingBalance: string;
	owner: string;
	used: boolean;
	renumbered: boolean;
	gratuityId: number;
	queueDateTime: string;
	futureOrderTime: Date;
	numberOfGuests: number;
	customerKey: string;
	firstName: string;
	lastName: string;
	phone: string;
	email: string;
	address: string;
	address2: string;
	city: string;
	state: string;
	zip: string;
	deliveryDirections: null;
	smsmessage: string;
	revenueCenter: null;
	status: number;
	licenseKey: string;
	pos: boolean;
	smsSent: string;
	autoClosed: string;
	loyaltyAccount: null;
	loyaltyStatus: number;
	externalId: null;
	error: string;
	marketingOptIn: number;
	seats: CheckSeat[];
	receiptToken: string;
	receiptUrl: string;
	receiptShortUrl: string;
	ooUrl: string;
	ooShortUrl: string;

	public constructor(init?: Partial<Check>) {
		Object.assign(this, init);
	}
}
